import React from "react";
export interface VisualContextValue {
    showConfetti: (type: string) => void;
}

export const VisualEffectContext = React.createContext<VisualContextValue>({
    showConfetti: () => void 0,
});

if (__DEV__) {
    VisualEffectContext.displayName = "VisualEffectContext";
}
